import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

    html {
        overflow-y: scroll; // avoids layout moving when scrollbar isn't needed
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    body {
        font-family: 'Montserrat', sans-serif;
        background-color: #F7F7F7;
    }

    strong {
        font-family: 'Montserrat', sans-serif!important;
        font-weight:700;
    }

    .nowrap {
        white-space:nowrap;
    }


`;

export default GlobalStyle;
